<template>
  <v-card-text class="ml-0 pl-0 pr-0">

    <div
      v-for="message in messages"
      :key="message.id"
    >
      <div v-if="message.text != ''">
        <h6>
          <template v-if="message.fromPersonalNumber === message.toPersonalNumber">
            Från BYN till
            <b>{{ message.fromName }}</b>
          </template>

          <template v-else>
            Från {{ message.fromName }} till
            <b>{{ message.toName }}</b>
          </template>
          <span class="date_time"> ({{ message.sentTime | date }})</span>
        </h6>
        <p
          class="body-1"
          v-html="message.text"
        ></p>
      </div>
    </div>

  </v-card-text>
</template>

<script>
export default {
  name: 'ApplicationMessagesView',

  props: {
    messages: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>